import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useProject = (projectId: string) => {
  const projectPath = ENDPOINTS.PROJECTS.byProjectId(projectId)
  const endpoint = projectId ? projectPath : null

  const { data, error, mutate } = useSWR(endpoint, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}

/*
export const useProjectAndPopulate = (projectId: string) => {
  const endpoint = projectId ? getProjectSettings_endpoint(projectId) : null
  const { data, error } = useSWR(endpoint, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
  }
}

export const useProjectGetFiles = (projectId: string) => {
  const endpoint = projectId ? getFiles_endpoint(projectId) : null
  const { data, error } = useSWR(endpoint, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
  }
}
*/
